export const TARGETING_SET_ACL_OBJECTS = [
    'TargetingSetCreate',
    'TargetingSetList',
    'TargetingSetView'
];
